import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: white;
  padding: 1.5rem 0;
`;

export const Title = styled("h4")`
  font-size: 1.3rem;
  text-transform: capitalize;
  color: rgb(75, 58, 88);

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(122, 93, 163);
  }
`;

export const Extra = styled("section")`
  background: white;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 0;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: rgb(75, 58, 88);
  font-size: 1.1rem;
  width: 70%;
`;

export const Large = styled(Link)`
  font-size: 1.1rem;
  color: rgb(75, 58, 88);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: rgb(122, 93, 163);
    text-underline-position: under;
    text-decoration: rgb(122, 93, 163) wavy underline;
  }
`;

export const Chat = styled("p")`
  color: rgb(75, 58, 88);
  max-width: fit-content;
  border-bottom: 1px solid rgb(75, 58, 88);
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;
  font-size: 1.1rem;

  &:hover {
    border-bottom: 1px solid rgb(122, 93, 163);
    color: rgb(122, 93, 163);
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const Language = styled("h4")`
  font-size: 1.3rem;
  text-transform: capitalize;
  color: rgb(75, 58, 88);

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;


